import Check from './Check.svg'
import Close from './Close.svg'
import EditPencil from './EditPencil.svg'
import Heart from './Heart.svg'
import Link from './Link.svg'
import Filter from './Filter.svg'
import Note from './Note.svg'
import Star from './Star.svg'
import DragHandle from './DragHandle.svg'
import GarbageBin from './GarbageBin.svg'
import LightBulb from './LightBulb.svg'
import Minus from './Minus.svg'
import Plus from './Plus.svg'
import AppleLogo from './AppleLogo.svg'
import GooglePlayLogo from './GooglePlayLogo.svg'
import ChromeExtension from './ChromeExtension.svg'
import Divider from './Divider.svg'
import Eye from './Eye.svg'
import Lock from './Lock.svg'
import MagnifyingGlass from './MagnifyingGlass.svg'
import RightArrow from './RightArrow.svg'
import RightChevron from './RightChevron.svg'
import Share from './Share.svg'
import Chevron from './Chevron.svg'
import CashFundIcon from './CashFundIcon.svg'
import GroupGiftIcon from './GroupGiftIcon.svg'
import Clipboard from './Clipboard.svg'
import LockOpen from './LockOpen.svg'
import UserOutline from './UserOutline.svg'

export {
  AppleLogo,
  CashFundIcon,
  Check,
  Chevron,
  ChromeExtension,
  Close,
  Clipboard,
  Divider,
  DragHandle,
  EditPencil,
  Eye,
  Filter,
  GarbageBin,
  GooglePlayLogo,
  GroupGiftIcon,
  Heart,
  Link,
  LightBulb,
  Lock,
  LockOpen,
  MagnifyingGlass,
  Minus,
  Note,
  Plus,
  RightArrow,
  RightChevron,
  Share,
  Star,
  UserOutline,
}
